import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, message, Select } from 'antd';

import {
  findInvalidEmail,
  hasDuplicateNormalizedEmail,
  uniqueNormalizedEmailList,
} from '../../utils/email';

type SelectManagersProps = {
  managerEmails?: string[];
  skipLabel?: boolean;
};

export const SelectManagers: FC<SelectManagersProps> = ({
  managerEmails,
  skipLabel = false,
}) => {
  const { t } = useTranslation();
  const normalizedManagerEmails = uniqueNormalizedEmailList(managerEmails);

  return (
    <Form.Item
      name="managerEmails"
      className="m-0 mb-6"
      initialValue={normalizedManagerEmails}
      normalize={(emails?: string[]) => uniqueNormalizedEmailList(emails)}
      rules={[
        {
          validator: (_, emails?: string[]) => {
            if (findInvalidEmail(emails)) {
              return Promise.reject(
                new Error(t('components.SelectManagers.invalidEmail')),
              );
            }

            if (hasDuplicateNormalizedEmail(emails)) {
              return Promise.reject(
                new Error(t('components.SelectManagers.duplicateEmail')),
              );
            }

            return Promise.resolve();
          },
        },
      ]}
      validateTrigger={['onChange', 'onBlur']}
      {...(!skipLabel && { label: t('components.SelectManagers.managers') })}>
      <Select
        placeholder={t('components.SelectManagers.enterManagers')}
        mode="tags"
        tokenSeparators={[',', ';', ' ']}
        onChange={(emails) => {
          if (hasDuplicateNormalizedEmail(emails)) {
            message.warning(t('components.SelectManagers.duplicateEmail'));
          }
        }}
        allowClear>
        {normalizedManagerEmails?.map((email) => (
          <Select.Option key={email} value={email} title={email}>
            {email}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
